//@flow

// Older browsers may not support window.performance or getEntriesByType

export default function safeGetEntriesByType(type: string) {
  return window.performance && window.performance.getEntriesByType
    ? window.performance.getEntriesByType(type)
    : [];
}
